<script>
import CompanyTabLayout from '@/components/company/CompanyTabLayout.vue';
import UsersList from '@/pages/users/UsersList.vue';

export default {
  components: {
    CompanyTabLayout,
    UsersList,
  },
};
</script>

<template>
  <CompanyTabLayout active-tab="users" v-slot="{ companyId }">
    <UsersList :company-id="companyId" />
  </CompanyTabLayout>
</template>
